import { Component } from '@angular/core';

@Component({
  selector: 'app-ds-header',
  standalone: true,
  imports: [],
  templateUrl: './ds-header.component.html',
})
export class DsHeaderComponent {

}
